import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_USERS } from "../../../utils/constants";
import { UserInterface } from "../../../models/UserModel/User";
import userService from "../../../services/userService/userService";

const useUserByEmail = (email: string) =>
  useQuery<UserInterface, Error>({
    queryKey: [`${CACHE_KEY_USERS}ByEmail`, email],
    queryFn: ({ queryKey }) => {
      const [, userId] = queryKey;
      return userService.GetByEmail(userId as string);
    },
    enabled: !!email,
  });

export default useUserByEmail;
